import React, { useEffect, useState } from "react";
import { Tabs, Tab, Button } from "react-bootstrap";

import { BasicInformationTab } from "./BasicInformationTab";
import { UiConfigurationTab } from "./UiConfigurationTab";
import {
  fecthTz,
  fetchNumberSequence,
} from "../businessGroup/businessGroupSlice";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
  fetchParameter5,
  fetchParameter6,
  fetchParameter7,
  fetchParameter8,
} from "../businessParameter/businessParameterSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchIdOffice,
  selectIdOffice,
  selectLoading,
  setPermissionBasicInfo,
  setPermissionConfiguration,
} from "./officeSlice";
import { useHistory, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { fetchCountryAll } from "../location/locationSlice";
import { selectDefaultTab } from "../user/userSlice";
import { fetchMenuTab, selectMenuTab } from "../menu/menuSlice";
import { checkMenu } from "../../utility";

export const OfficeEdit = () => {
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);
  const { id } = useParams();
  const history = useHistory();
  const dataId = useSelector(selectIdOffice);
  const defaultTab = useSelector(selectDefaultTab);
  const dataMenuTab = useSelector(selectMenuTab);

  const [list, setList] = useState(null);
  const [active, setActive] = useState("");

  const [culture, setCulture] = useState("");
  const [dateFormat, setDateFormat] = useState("");
  const [pagination, setPagination] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [digitGrouping, setDigitGrouping] = useState("");

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load

      await dispatch(
        fetchMenuTab({
          menu_url: "/administration/office-management",
        })
      );

      await dispatch(fetchIdOffice(id));
      await dispatch(fecthTz());

      await dispatch(
        fetchCountryAll({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "PHONETYPE",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter3({
          paramgroup_code: "DIGITGROUPING",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter4({
          paramgroup_code: "PAGINATION",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter5({
          paramgroup_code: "DATEFORMAT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter6({
          paramgroup_code: "CULTURE",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter7({
          paramgroup_code: "PATTERNS",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter8({
          paramgroup_code: "OFFICE_TYPE",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchNumberSequence({
          pageNo: 1,
          pageSize: -1,
        })
      );
    }

    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      console.log(data, "data");
      setList(data);
      setActive(data[0]);
      // dispatch(setDefaultTab(data[0]));
      const master = dataMenuTab.map((item, index) => {
        if (item.menu_name === "Basic Information") {
          return dispatch(setPermissionBasicInfo(item.permissions));
        }
        if (item.menu_name === "UI Configuration") {
          return dispatch(setPermissionConfiguration(item.permissions));
        }
      });
    }
  }, [dataMenuTab]);

  const typesUi = ["Display Settings", "Sequencing"];
  const [activeUi, setActiveUi] = useState(typesUi[0]);

  const typesBasic = ["General Information", "Co-Branding"];

  const [activeBasic, setActiveBasic] = useState(typesBasic[0]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    dataId && list && (
      <>
        <div>
          <Tabs
            // defaultActiveKey="Basic Information"
            id="uncontrolled-tab-example"
            className="mt-5"
            activeKey={active}
            onSelect={(e) => {
              setActive(e);
            }}
          >
            {checkMenu(list, "Basic Information") && (
              <Tab eventKey="Basic Information" title="Basic Information">
                <BasicInformationTab
                  active={activeBasic}
                  setActive={setActiveBasic}
                  types={typesBasic}
                />
              </Tab>
            )}
            {checkMenu(list, "UI Configuration") && (
              <Tab eventKey="UI Configuration" title="UI Configuration">
                <UiConfigurationTab
                  culture={culture}
                  setCulture={setCulture}
                  dateFormat={dateFormat}
                  setDateFormat={setDateFormat}
                  pagination={pagination}
                  setPagination={setPagination}
                  timeZone={timeZone}
                  setTimeZone={setTimeZone}
                  digitGrouping={digitGrouping}
                  setDigitGrouping={setDigitGrouping}
                  active={activeUi}
                  setActive={setActiveUi}
                  types={typesUi}
                />
              </Tab>
            )}
          </Tabs>
        </div>
      </>
    )
  );
};
